const Shimmer = () => {
    return (
        <div className="restaurant-container">
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>
            <div className="shimmer-card" ></div>


        </div>
    );
}
export default Shimmer;